var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isDirty)?_c('b-button',{staticClass:"float-right ml-1",attrs:{"variant":_vm.activeTemplate ? 'warning' : 'success',"tabindex":"3"},on:{"click":_vm.onSaveTemplate}},[_vm._v(_vm._s(_vm.activeTemplate ? 'Update Template' : 'Create Template'))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }